// document.addEventListener("DOMContentLoaded", () => {
//   const availabilityCheckbox = document.querySelector('[name="filter.v.availability"]');
//   if (availabilityCheckbox && !availabilityCheckbox.checked) {
//     availabilityCheckbox.click();
//   }
// });
$(function() {
  var current_o_pro_carousel;
  if(jQuery('body').find('.image-wrap-pspecialslider.owl-carousel').length){
    current_o_pro_carousel = jQuery('body').find('.image-wrap-pspecialslider.owl-carousel').owlCarousel({
      loop:true,
      dots: false,
      nav: true,
      navText:['<div class="prevnextbg"></div><i class="fa fa-chevron-left oprevbtn"></i>','<div class="prevnextbg"></div><i class="fa fa-chevron-right onextbtn"></i>'],
      responsive:{
        0:{items:1},
        600:{items:1},
        1000:{items:1}
      }
    });
    // While collection page refresh by ajax
    document.addEventListener('collection:reloaded', function() {
      current_o_pro_carousel.trigger('destroy.owl.carousel');
      current_o_pro_carousel = jQuery('body').find('.image-wrap-pspecialslider.owl-carousel').owlCarousel({
        loop:true,
        dots: false,
        nav: true,
        navText:['<div class="prevnextbg"></div><i class="fa fa-chevron-left oprevbtn"></i>','<div class="prevnextbg"></div><i class="fa fa-chevron-right onextbtn"></i>'],
        responsive:{
          0:{items:1},
          600:{items:1},
          1000:{items:1}
        }
      });
    });
  }
});